import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function B() {
    const { useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-B .viewport-wrapper .desc', { opacity: 0, scale: 1.3 }, { opacity: 1, scale: 1 }]],
            triggerElement: '.wave2-detail-B .viewport-wrapper',
            triggerHook: 1,
            offset: '20%',
            duration: '30%',
        });
        AniContainer.create({
            syncFromTo: [['.wave2-detail-B .viewport-wrapper .overview-wrapper', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-B .viewport-wrapper',
            triggerHook: 1,
            offset: '25%',
            duration: '30%',
        });
    }, []);

    return (
        <div className={`wave2-detail-B ${css.wave2DetailB}`}>
            <div className="viewport-wrapper">
                <p className="desc">{t('teaser.sectionA_desc')}</p>
                <div className="overview-wrapper">
                    <div className="grid-1">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/overview_1.webp')}
                            src={require('@publicLocal/wave2/detail/pc/overview_1.jpg')}
                            alt={t('detail.sectionB_1')}
                            aria-label={t('detail.sectionB_1')}
                            width={260}
                            height={270}
                        />
                        <div className="text">
                            <p className="text1">{t('detail.sectionB_1')}</p>
                            <p className="text2">{t('detail.sectionB_2')}</p>
                        </div>
                    </div>
                    <div className="grid-2">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/overview_2.webp')}
                            src={require('@publicLocal/wave2/detail/pc/overview_2.jpg')}
                            alt={t('detail.sectionB_3')}
                            aria-label={t('detail.sectionB_3')}
                            width={516}
                            height={516}
                        />
                        <p className="text">
                            {t.rich('detail.sectionB_3', {
                                line0: (text0: any) => <span className="text-0">{text0}</span>,
                                line1: (text1: any) => <span className="text-blue">{text1}</span>,
                                line3: (text3: any) => <em className="text-other">{text3}</em>,
                                line2: (text2: any) => <span className="text-orange">{text2}</span>,
                            })}
                        </p>
                    </div>
                    <div className="grid-3">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/overview_3.webp')}
                            src={require('@publicLocal/wave2/detail/pc/overview_3.jpg')}
                            alt={t('detail.sectionB_4')}
                            aria-label={t('detail.sectionB_4')}
                            width={260}
                            height={224}
                        />
                        <div className="text">
                            <p className="text1">{t('detail.sectionB_4')}</p>
                            <p className="text2">
                                {t.rich('detail.sectionB_5', {
                                    line1: (text1: any) => <span className="right">{text1}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="grid-4">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/overview_4.webp')}
                            src={require('@publicLocal/wave2/detail/pc/overview_4.jpg')}
                            alt={t('detail.sectionB_6')}
                            aria-label={t('detail.sectionB_6')}
                            width={260}
                            height={230}
                        />
                        <p className="text">{t('detail.sectionB_6')}</p>
                    </div>
                    <div className="grid-5">
                        <div className="top">
                            <NextImage
                                webpSrc={require('@publicLocal/wave2/detail/pc/overview_5.webp')}
                                src={require('@publicLocal/wave2/detail/pc/overview_5.jpg')}
                                alt={t('detail.sectionB_8')}
                                aria-label={t('detail.sectionB_8')}
                                width={260}
                                height={130}
                            />
                            <p className="text">{t('detail.sectionB_8')}</p>
                        </div>
                        <div className="bottom">
                            <NextImage
                                webpSrc={require('@publicLocal/wave2/detail/pc/overview_6.webp')}
                                src={require('@publicLocal/wave2/detail/pc/overview_6.jpg')}
                                alt={t('detail.sectionB_7')}
                                aria-label={t('detail.sectionB_7')}
                                width={260}
                                height={130}
                            />
                            <p className="text">{t('detail.sectionB_7')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
